import { render, staticRenderFns } from "./DialogFornecedoresRessuprir.vue?vue&type=template&id=5318ba2e&scoped=true"
import script from "./DialogFornecedoresRessuprir.vue?vue&type=script&lang=js"
export * from "./DialogFornecedoresRessuprir.vue?vue&type=script&lang=js"
import style0 from "./DialogFornecedoresRessuprir.vue?vue&type=style&index=0&id=5318ba2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318ba2e",
  null
  
)

export default component.exports